module.exports = __webpack_public_path__ + "static/media/destination-offline.75c82dda.png";